import mobileLogo from '../../../assets/Name - White Transparent.svg'
import styled, { css } from 'styled-components/macro'
import MobileSlideOutMenu, { MobileNavItem } from './MobileSlideOutMenu'
import {
  PiHouse,
  PiHouseFill,
  PiHandshake,
  PiHandshakeFill,
  PiCalendarStar,
  PiCalendarStarFill,
  PiGear,
  PiGearFill,
  PiIdentificationCard,
  PiIdentificationCardFill,
  PiList,
} from 'react-icons/pi'
import { useClickOutside } from 'hooks/useClickOutside'
import { useState } from 'react'
import { NotificationButton } from 'components/Notification/NotificationButton'
import * as S from './styles'

const HamburgerMenu = css`
  cursor: pointer;
  color: white;
  font-size: 26px;
  height: 50px;
  width: 50px;
  padding: 10px;
`

export const HamburgerMenuIcon = styled(PiList)`
  ${HamburgerMenu}
`

export const menuItems: MobileNavItem[] = [
  { icon: PiHouse, activeIcon: PiHouseFill, label: 'Home', to: '/' },
  {
    icon: PiHandshake,
    activeIcon: PiHandshakeFill,
    label: 'Deals',
    to: '/deals',
  },
  {
    icon: PiIdentificationCard,
    activeIcon: PiIdentificationCardFill,
    label: 'Contacts',
    to: '/contacts',
  },
  {
    icon: PiCalendarStar,
    activeIcon: PiCalendarStarFill,
    label: 'Reminders',
    to: '/reminders',
  },
  {
    icon: PiGear,
    activeIcon: PiGearFill,
    label: 'Settings',
    to: '/settings',
  },
]

export function MobileAuthenticatedNav() {
  const [isSlideOutOpen, setIsSlideOutOpen] = useState(false)

  const handleOpenSlideOut = () => {
    setIsSlideOutOpen(false)
  }

  const ref = useClickOutside<HTMLDivElement>(handleOpenSlideOut)

  return (
    <S.MobileWrapper ref={ref}>
      <S.MobileNavContent>
        <S.MobileNavLeft>
          <HamburgerMenuIcon onClick={() => setIsSlideOutOpen(true)} />
          <S.LogoImg width="81px" src={mobileLogo} alt="mobileLogo" />
        </S.MobileNavLeft>
        <NotificationButton />
      </S.MobileNavContent>
      {isSlideOutOpen && (
        <MobileSlideOutMenu
          isOpen={isSlideOutOpen}
          items={menuItems}
          onClose={() => setIsSlideOutOpen(false)}
        />
      )}
    </S.MobileWrapper>
  )
}
